const API_VER = 'v1.0'
export const CMSEndpoints = {
    CMS_CREDENTIAL_URI: `/cms/api/${API_VER}/credentials/`,
}
